exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.editor-container {\n  overflow: hidden; /* Ensures smooth transitions */\n  resize: none; /* Prevents manual resizing */\n}\n.editor-container[disabled=\"disabled\"] {\n  background-color: #eceeef;\n  cursor: not-allowed;\n}\n", ""]);

// exports
